import { RefObject, useEffect, useRef } from 'react';

export default function useScrollIntoViewOnFocus({
  refToScroll,
  offset = 0,
}: {
  refToScroll?: RefObject<HTMLElement>;
  offset?: number;
}) {
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const handleFocus = () => {
      setTimeout(() => {
        const y = ((refToScroll?.current ?? element)?.getBoundingClientRect().top ?? 0) + window.scrollY + offset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 200);
    };

    element.addEventListener('focus', handleFocus);
    return () => {
      element.removeEventListener('focus', handleFocus);
    };
  }, [refToScroll, offset]);

  return ref;
}
